module.exports = __webpack_public_path__ + "media/Out.14df7493.mp3";